import { useEffect, useState } from "react"
import mainservice from "../../../services/MainService"
import ItemCustomerDTO from "../../DTO/ItemCustomerDTO"
import UserDisplayById from "../../../components/User/UserDisplayById"
import { Setter } from "../../../services/ComService"
import { Box, Button, Stack } from "@mui/material"
import { RightDrawerContent } from "../RightDrawer"
import { UserCustomerFkt } from "../../DTO/UserCustomerFktDTO"

export default function Responsibility ({
  customer,
}: {
  customer: ItemCustomerDTO
}) {
  const [userId, setUserId] = useState(customer.getUserFkt(UserCustomerFkt.manager))
  const broadcastSelectUserKey = `Responsibility-chg-usr-${customer.id}`
  mainservice.registerToBroadcast(broadcastSelectUserKey,
    (key: string, value: {userId: number}) => {
      console.log('broadcastSelectUserKey', key, value)
      if (key !== broadcastSelectUserKey) {return}
      if (value.userId < 0) {return}
      // Hier kommt dann die User ID zurück, (im value), die wir dann verarbeiten müssen:
      setUserId(value.userId)
      Setter(`userCustomerFkt`, {
        customerId: customer.id,
        userId: value.userId,
        fkt: UserCustomerFkt.manager,
        status: 1,
      }, {
        method: 'PUT'
      })
    }
  )
  return <Stack
    direction='column'
    spacing={2}
  >
    <Box>
      <UserDisplayById id={userId} /> [{userId}]
    </Box>
    <Box>
      <Button
        variant='outlined'
        onClick={() => {
          mainservice.broadcast('rightDrawerOpen', {
            contentType: RightDrawerContent.selectResponsibleForCustomer,
            broadCastBackKey: broadcastSelectUserKey,
          })
        }}
      >
        Verantwortlichen wählen
      </Button>
    </Box>
  </Stack>
}
